export const ticketState = [
  {
    id: 'ISSUED',
    label: 'vydaný'
  },
  {
    id: 'USED_BNZ',
    label: 'použitý BNZ'
  },
  {
    id: 'USED_BNP',
    label: 'použitý BNP'
  },
  {
    id: 'USED_REBUKE',
    label: 'použitý domluvou'
  },
  {
    id: 'USED_NT',
    label: 'použitá stěračenka'
  },
  {
    id: 'DEMAND_BNP',
    label: 'předáno BNP k vymáhání'
  },
  {
    id: 'COLLECTED',
    label: 'zaplaceno BNP'
  },
  {
    id: 'HANDED_OVER_CASH',
    label: 'odevzdaná hotovost'
  },
  {
    id: 'CANCELED',
    label: 'zrušený'
  }
];

export const ticketType = [
  { id: 'BNP', label: 'blok na místě nezaplacený' },
  { id: 'BNZ', label: 'pokutový blok' },
  { id: 'NT', label: 'stěračenka' }
];

export const paymentMethod = [
  { id: 'CASH', label: 'hotově' },
  { id: 'CHECK', label: 'kartou' },
  { id: 'WIRE', label: 'přes účet' },
  { id: 'EXTERNAL', label: 'externí' },
  { id: 'DEMANDED', label: 'vymáháno' },
  { id: 'DEPRECATED', label: 'odepsáno' },
  { id: 'TABLET', label: 'kartou přes tablet' }
];



// WEBPACK FOOTER //
// ./src/modules/tickets/_ticketsEnums.ts